<template>
  <div>
    <customer-referrer-add-modal />
    <div class="vstack gap-4">
      <epi-card title="고객 정보">
        <template v-slot:body>
          <div class="row align-items-center">
            <div class="col-3 col-md-2">이름</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                placeholder="이름을 입력해주세요"
              />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">이메일</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                placeholder="이메일을 입력해주세요"
              />
            </div>
            <div class="mb-1"></div>
            <div class="col-9 col-md-10 offset-3 offset-md-2">
              <div class="form-check">
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="preferredContact"
                  />
                  선호하는 연락처</label
                >
              </div>
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">휴대폰</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                placeholder="휴대폰 번호를 입력해주세요"
              />
            </div>
            <div class="mb-1"></div>
            <div class="col-9 col-md-10 offset-3 offset-md-2">
              <div class="form-check">
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="preferredContact"
                  />
                  선호하는 연락처</label
                >
              </div>
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">담당 상담사</div>
            <div class="col-9 col-md-10">
              <epi-select placeholder="김에피" />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">경로</div>
            <div class="col-9 col-md-10">
              <div class="d-flex gap-2 align-items-center">
                <epi-select
                  placeholder="고객과 만난 경로(예: EAP)"
                  class="w-100"
                />
                <button
                  class="btn btn-primary circle-30"
                  @click="clickCustomerReferrerAdd"
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </template>
      </epi-card>

      <epi-card title="고객 상세 정보">
        <template v-slot:body>
          <div class="row align-items-center">
            <div class="col-3 col-md-2">주소</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                placeholder="주소를 입력해주세요"
              />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">생년월일</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                placeholder="생년월일을 입력해주세요"
              />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">성별</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                placeholder="성별을 입력해주세요"
              />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">비고</div>
            <div class="col-9 col-md-10">
              <input type="text" class="form-control" placeholder="비고" />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">종결일</div>
            <div class="col-9 col-md-10">
              <div class="d-flex gap-2">
                <epi-date-picker />
                <a href="javascript:0" class="btn text-danger"
                  ><i class="bi bi-repeat"></i
                ></a>
              </div>
            </div>
          </div>
        </template>
      </epi-card>

      <epi-card title="비상 연락망">
        <template v-slot:title-menu>
          <button class="btn btn-sm btn-primary" @click="clickExtraContactAdd">
            추가
          </button>
        </template>
        <template v-slot:body>
          <div
            class="row align-items-center"
            v-for="c in extraContacts"
            :key="c.id"
          >
            <div class="col-3 col-md-2">이름</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                v-model="c.name"
                placeholder="이름을 입력해주세요"
              />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">이메일</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                v-model="c.email"
                placeholder="이메일을 입력해주세요"
              />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">휴대폰</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                v-model="c.phone"
                placeholder="휴대폰을 입력해주세요"
              />
            </div>

            <div class="mb-3"></div>

            <div class="col-3 col-md-2">관계</div>
            <div class="col-9 col-md-10">
              <input
                type="text"
                class="form-control"
                v-model="c.relation"
                placeholder="고객과의 관계를 입력해주세요"
              />
            </div>

            <template v-if="extraContacts.indexOf(c) > 0">
              <div class="mb-3"></div>
              <div class="col-9 col-md-10 offset-3 offset-md-2">
                <button
                  class="btn btn-primary"
                  @click="clickExtraContactRemove(c.id)"
                >
                  삭제
                </button>
              </div>
            </template>

            <hr class="my-4" />
          </div>
        </template>
      </epi-card>

      <epi-card title="관계">
        <template v-slot:title-menu>
          <i
            class="bi bi-info-circle text-warning"
            data-bs-toggle="tooltip"
            data-bs-title="설명"
          ></i>
          <button class="btn btn-sm btn-primary" @click="clickRelationAdd">
            추가
          </button>
        </template>
        <template v-slot:body>
          <div
            class="d-flex gap-2 align-items-center"
            v-for="r in relations"
            :key="r.id"
          >
            <span class="flex-fill" style="word-break: keep-all">고객과</span>
            <epi-select
              placeholder="고객"
              v-model="r.person"
              style="min-width: 80px"
            />
            <span>은</span>
            <input
              type="text"
              class="form-control form-control mw-100"
              v-model="r.relation"
              placeholder="고객과의 관계를 입력해주세요. 예) 부부"
            />

            <template v-if="relations.indexOf(r) > 0">
              <button
                class="btn btn-primary"
                @click="clickRelationRemove(r.id)"
                style="min-width: 60px"
              >
                삭제
              </button>
            </template>

            <hr class="my-4" />
          </div>
          <div class="mb-3"></div>
        </template>
      </epi-card>
    </div>
  </div>
</template>

<script>
import { EventName } from "@/const";
import * as bootstrap from "bootstrap";

export default {
  name: "CustomerAddForm",
  data() {
    return {
      extraContacts: [],
      relations: [],
    };
  },
  methods: {
    clickCustomerReferrerAdd() {
      this.$root.$emit(EventName.CustomerReferrerAddModalOpening);
    },
    clickExtraContactAdd() {
      this.extraContacts.push({
        id: this.extraContacts.length,
        name: "",
        email: "",
        phone: "",
        relation: "",
      });
    },
    clickExtraContactRemove(id) {
      const idx = this.extraContacts.findIndex((a) => a.id === id);
      if (idx < 0) return;
      this.extraContacts.splice(idx, 1);
    },
    clickRelationAdd() {
      this.relations.push({
        id: this.relations.length,
        person: "",
        relation: "",
      });
    },
    clickRelationRemove(id) {
      const idx = this.relations.findIndex((a) => a.id === id);
      if (idx < 0) return;
      this.relations.splice(idx, 1);
    },
  },
  mounted() {
    this.clickExtraContactAdd();
    this.clickRelationAdd();

    [...document.querySelectorAll("[data-bs-toggle='tooltip']")].map(
      (el) => new bootstrap.Tooltip(el)
    );
  },
};
</script>
